module.exports = __webpack_public_path__ + "static/olowoselu-02e63f62bac8d3552e003790aa670d39.png";